import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreateSolicitudGastosTransporte = () => {
  const [loadingCreateSolicitudGastosTransporte, setLoadingCreateSolicitudGastosTransporte] = useState(false);
  const [successCreateSolicitudGastosTransporte, setSuccessCreateSolicitudGastosTransporte] = useState(false);
  const [errorCreateSolicitudGastosTransporte, setErrorCreateSolicitudGastosTransporte] = useState(null);
  const [dataCreateSolicitudGastosTransporte, setDataSolicitudGastosTransporte] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const createSolicitudGastosTransporte = async (
    userId: string,
    data: any,
    _cb?: (data: any) => void
  ) => {
    setLoadingCreateSolicitudGastosTransporte(true);
    setSuccessCreateSolicitudGastosTransporte(false);
    setErrorCreateSolicitudGastosTransporte(null);

    try {
      const payload = {
        ...data,
        UsuarioId: data?.UsuarioId ?? userId,
      };
      const res = await apiRecord.newSolicitudGastosContingenciaProfesionalTransporte(userId, payload);

      setSuccessCreateSolicitudGastosTransporte(true);
      setDataSolicitudGastosTransporte(res.data);
      _cb?.(res.data);

      return res.data;
    } catch (err: any) {
      console.error("Error en createSolicitudGastosTransporte:", err);
      setErrorCreateSolicitudGastosTransporte(err.response?.data ?? err);

      throw err;
    } finally {
      setLoadingCreateSolicitudGastosTransporte(false);
    }
  };

  return {
    createSolicitudGastosTransporte,
    loadingCreateSolicitudGastosTransporte,
    successCreateSolicitudGastosTransporte,
    errorCreateSolicitudGastosTransporte,
    dataCreateSolicitudGastosTransporte
  };
};

export default useCreateSolicitudGastosTransporte;
